import {useEffect, useState} from "react";

export const DataTable = ({data}) => {
    const [columns, setColumns] = useState(null);

    useEffect(() => {
        if (data) {
            setColumns(Object.keys(data[0]));
        }
    }, [data]);

    if (columns) {
        return (
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                    <thead>
                        <tr>
                            {columns.map((column, index) => (
                                <th key={index} className="px-4 py-2 text-left text-gray-600 font-semibold">
                                    {column}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {columns.map((col, colIndex) => (
                                    <td key={rowIndex + "_" + colIndex} className="border px-4 py-2">
                                        {row[col]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}